// extracted by mini-css-extract-plugin
export var hidden = "tabs-module--hidden--8ada8";
export var tabs = "tabs-module--tabs--d2be5";